import { render } from "./NavigationCarousel.vue?vue&type=template&id=d50defd0&scoped=true"
import script from "./NavigationCarousel.vue?vue&type=script&lang=js"
export * from "./NavigationCarousel.vue?vue&type=script&lang=js"

import "./NavigationCarousel.vue?vue&type=style&index=0&id=d50defd0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d50defd0"]])

export default __exports__